import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NavigationService } from 'src/app/core/service/navigation.service';
import { UrlServices } from 'src/app/helper/class/url-services';
import { cloneData } from 'src/app/helper/class/utilityHelper';
import { mapInfoView } from 'src/app/helper/interface/form-interface';
import { pageInfo } from 'src/app/helper/interface/menu-interface';
import { AlertService } from 'src/app/helper/service/alert.service';
import { StaffApiService } from '../../service/staff-api.service';
import { STAFF_FORM } from '../helper/staff_form';
import { ModalService } from 'src/app/shared/service/modal.service';

@Component({
  selector: 'app-staff-info',
  templateUrl: './staff-info.component.html',
  styleUrls: ['./staff-info.component.scss']
})
export class StaffInfoComponent {
  urlService = UrlServices.PAGE_URL;
  dataLoading: boolean = false
  isModal: boolean = false;
  staffData: any = {};
  staffId: any;
  staffFormData: any = [...cloneData(STAFF_FORM)];
  otherInfo: mapInfoView[] = [
    { name: 'statusName', title: 'status' },
    { title: 'Date of joining', name: 'do_join', type: 'DATE' },
    { name: 'created_byName', title: 'Created by' }, { title: 'created On', name: 'created_at', type: 'DATE' },
    { name: 'last_modify_byName', title: 'Last Modify' }, { title: 'Last update On', name: 'updated_at', type: 'DATE' }]
  pageInfo: pageInfo =
    {
      title: 'Staff Info',
      buttonShowBtn: true, button: { title: 'All Staff', url: this.urlService.STAFF.LIST.URL }
    }
  constructor(
    private activatedRoute: ActivatedRoute, private alertServe: AlertService, private navServe: NavigationService,
    private staffApi: StaffApiService, private router: Router, private modalService: ModalService) { }
  ngOnInit() {
    this.staffId = this.activatedRoute.snapshot.queryParams['id'] || 13
    if (this.staffId) {
      this.getData()
    } else {
      this.alertServe.showToast('Staff Not Found');
      this.navServe.back();
      return;
    }
  }

  setInput(staffId) {
    if (staffId) {
      console.log('--hi', staffId);
      this.staffId = staffId
      this.getData()
      this.isModal = true
    }
  }

  getData() {
    this.dataLoading = true;
    this.staffApi.getDetails(this.staffId).then((a: any) => {
      this.staffData = a.result
      console.log('data', this.staffData)
      this.staffData.name = `<span> ${this.staffData.titleName || ''} ${this.staffData.name} </span>`
      this.checkActive()
    }).finally(() => this.dataLoading = false)
  }

  checkActive() {
    this.otherInfo.push({
      name: this.staffData.status == 1 ? 'remarks' : 'reason_relive',
      title: this.staffData.status == 1 ? 'Remarks' : 'Reason'
    });
  }

  goEdit() {
    this.router.navigate([this.urlService.STAFF.ADD.URL], { queryParams: { id: this.staffId } })
  }

  goBack() {
    this.isModal ? this.modalService.close() : this.navServe.back()
  }
}